import React from 'react';
import PropTypes from 'prop-types';
import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Panic from 'Errors/Panic';
import { getBorderRadius } from 'Components/utils';
import classNames from 'classnames';

export const PAPER_VARIANTS = [
  'mui', // respects elevation passed in
  'tight',
  'subtle',
  'outlined',
];

const styles = (theme) => ({
  root: {},
  rootRounded: {
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
});

export const convertToMuiPaperProps = (props) => {
  const {
    variant,
    elevation,
  } = props;

  switch (variant) {
    case 'mui':
      return {
        variant: 'elevation',
        elevation,
      };
    case 'tight':
      return {
        variant: 'elevation',
        elevation: 23, // This is an index in the Theme.js shadows array.
      };
    case 'subtle':
      return {
        variant: 'elevation',
        elevation: 24, // This is an index in the Theme.js shadows array.
      };
    case 'outlined':
      return {
        variant: 'outlined',
        // Elevation doesn't matter when it's an outline. This variant is provided by Material UI.
      };
    default:
      throw new Panic('invalid-variant', `variant must be one of: ${PAPER_VARIANTS}`, { variant });
  }
};

// We override the variant property to provide variants that are helpful to Facet developers.
const Paper = React.forwardRef((props, ref) => {
  const {
    classes,
    className,
    elevation,
    variant,
    rounded,
    ...rest
  } = props;
  const { root, rootRounded, ...restClasses } = classes;

  return (
    <MuiPaper
      {...rest}
      {...convertToMuiPaperProps({ variant, elevation })}
      classes={{
        ...restClasses,
        root: classNames(classes.root, className, {
          [classes.rootRounded]: rounded,
        }),
      }}
      ref={ref}
    />
  );
});

Paper.defaultProps = {
  elevation: null,
  rounded: false,
  variant: 'mui',
};

Paper.propTypes = {
  elevation: PropTypes.number,
  rounded: PropTypes.bool,
  variant: PropTypes.oneOf(PAPER_VARIANTS),
};

export default withStyles(styles)(Paper);
